module.exports = __webpack_public_path__ + "static/img/ic_distance_start@2x.cf95dbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_distance_start@2x.png
// module id = vhik
// module chunks = 1